/**
 * Alcance de lectura de Membresías por rol.
 *
 * El backend restringe `status=ALL|INACTIVE` y el detalle de una membresía inactiva
 * a los roles de plataforma; `ALIADO_ADMIN` y `CONTADOR` solo pueden consultar el
 * catálogo `ACTIVE`. La UI refleja esa restricción para no ofrecer un 403.
 */
import type { AdminRole } from '@goelectric/shared-types';

/** Roles que pueden filtrar y ver todos los estados del catálogo de membresías. */
export const MEMBERSHIPS_ALL_STATUS_ROLES: readonly AdminRole[] = [
  'SUPER_ADMIN',
  'SOPORTE_N3',
  'MARKETING',
];

/** `true` si el rol puede consultar estados distintos de `ACTIVE`. */
export function canFilterMembershipStatus(role: AdminRole | undefined): boolean {
  return role !== undefined && MEMBERSHIPS_ALL_STATUS_ROLES.includes(role);
}
